/* eslint-disable indent */
import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { number } from 'ng-brazil/number/validator';
import { IAlbum, Lightbox } from 'ngx-lightbox';
import { Mes } from '../models/mes';
import { VisualizadorPdfComponent } from '../visualizador-pdf/visualizador-pdf.component';
import { NotificacaoService } from './notificacao.service';
import { Router } from '@angular/router';
// import { VisualizadorPdfComponent } from '../visualizador-pdf/visualizador-pdf.component';

// Number.prototype.toFixedNoRounding = function(n) {
//   const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g")
//   const a = this.toString().match(reg)[0];
//   const dot = a.indexOf(".");
//   if (dot === -1) { // integer, insert decimal dot and pad up zeros
//       return a + "." + "0".repeat(n);
//   }
//   const b = n - (a.length - dot) + 1;
//   return b > 0 ? (a + "0".repeat(b)) : a;
// }

// jquery
declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class UtilitarioService {

  constructor(private platformLocation: PlatformLocation, public dialog: MatDialog, private lightbox: Lightbox,
    private notificacaoService: NotificacaoService, private router: Router,) { }

  calculaItensPorPagina(totalDeItens) {

    const listaDeItensPorPagina = [];

    const index = 10;

    for (let i = 0; i < totalDeItens; i = i + index) {
      listaDeItensPorPagina.push(i + index);
    }

    if (listaDeItensPorPagina.length > 0 === false) {
      listaDeItensPorPagina.push(10);
    }

    return listaDeItensPorPagina;
  }

  removeMascara(texto: string) {
    return texto.replace('.', '').replace('-', '').replace('/', '').replace('(', '').replace(')', '').replace('.', '').replace(' ', '');
  }

  formataNumero(numero: string) {

    if (!numero || numero === '' || numero === 'NaN') {
      numero = '0';
    }
    return Number(numero.replace(',', '.')).toFixed(2);
  }

  formataNumeroParaSalvar(numero: string) {
    if (!numero || numero === '' || numero === 'NaN' || Number(numero) === 0) {
      numero = '0';
    }

    return numero.replace(',', '').replace('.', ',');
  }

  formataDataParaSalvar(data: string) {
    const dt = new Date(data);
    return `${dt.getFullYear()}${(dt.getMonth() + 1).toString().padStart(2, '0')}${dt.getDate().toString().padStart(2, '0')}`;
  }

  retornaNumero(numero: string) {



    if (!numero || numero === '' || numero === 'NaN') {
      numero = '0';
    }

    numero = numero.toString();
    return Number(numero.replace(',', '.'));
  }

  retornaData(data: string) {
    return new Date(data);
  }

  converteParaData(data: string) {
    data = data.replace(' 00:00:00', '');
    return new Date(`${data.split('/')[1]}/${data.split('/')[0]}/${data.split('/')[2]}`);
  }

  converteParaDataPtBr(data: string) {
    data = data.replace(' 00:00:00', '');
    return new Date(`${data.split('/')[1]}/${data.split('/')[0]}/${data.split('/')[2]}`);
  }

  retornaNomeMes(nMes: number, abreviado?): string {
    switch (nMes) {
      case 1:
        return abreviado ? 'JAN' : 'Janeiro';
      case 2:
        return abreviado ? 'FEV' : 'Fevereiro';
      case 3:
        return abreviado ? 'MAR' : 'Março';
      case 4:
        return abreviado ? 'ABR' : 'Abril';
      case 5:
        return abreviado ? 'MAI' : 'Maio';
      case 6:
        return abreviado ? 'JUN' : 'Junho';
      case 7:
        return abreviado ? 'JUL' : 'Julho';
      case 8:
        return abreviado ? 'AGO' : 'Agosto';
      case 9:
        return abreviado ? 'SET' : 'Setembro';
      case 10:
        return abreviado ? 'OUT' : 'Outubro';
      case 11:
        return abreviado ? 'NOV' : 'Novembro';
      case 12:
        return abreviado ? 'DEZ' : 'Dezembro';
      default:
        return '';
    }
  }

  retornaDiferencaDeDias(data1: Date, data2: Date) {

    // The number of milliseconds in all UTC days (no DST)
    const oneDay = 1000 * 60 * 60 * 24;

    // A day in UTC always lasts 24 hours (unlike in other time formats)
    const data1UTC = Date.UTC(data1.getFullYear(), data1.getMonth(), data1.getDate());
    const data2UTC = Date.UTC(data2.getFullYear(), data2.getMonth(), data2.getDate());

    // so it's safe to divide by 24 hours
    return (data1UTC - data2UTC) / oneDay;
  }

  retornaListaDeMeses(): Mes[] {
    const meses: Mes[] = [];
    for (let index = 1; index <= 12; index++) {
      meses.push({ id: index.toString(), nome: this.retornaNomeMes(index) });
    }
    return meses;
  }

  retornaDiferencaDeSegundos(dt2, dt1) {
    const diff = (dt2.getTime() - dt1.getTime()) / 1000;
    return Math.abs(Math.round(diff));
  }

  retornaDiferencaDeMinutos(dt2, dt1) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    const resultado = Math.abs(Math.round(diff));
    return resultado;
  }

  retornaDiferencaDeHorasTimeSpan(data1: Date, data2: Date): string {
    const diffInMilliseconds = Math.abs(data1.getTime() - data2.getTime());
    const hours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffInMilliseconds % (1000 * 60)) / 1000);
    return `${hours}h ${minutes}m`;
  }

  retornaDiferencaDeHoras(data1: Date, data2: Date): number {
    const diffInMilliseconds = Math.abs(data1.getTime() - data2.getTime());
    return diffInMilliseconds / (1000 * 60 * 60);
  }

  retornaDiaDaSemana(dia) {
    switch (dia) {
      case 0:
        return 'Dom';
      case 1:
        return 'Seg';
      case 2:
        return 'Ter';
      case 3:
        return 'Qua';
      case 4:
        return 'Qui';
      case 5:
        return 'Sex';
      case 6:
        return 'Sab';
    }
  }

  private retornaTipoArquivo(filename: string) {
    const checkFileType = filename.split('.').pop();
    let fileType;
    if (checkFileType === '.txt') {
      fileType = 'text/plain';
    }
    if (checkFileType === '.pdf') {
      fileType = 'application/pdf';
    }
    if (checkFileType === '.doc') {
      fileType = 'application/vnd.ms-word';
    }
    if (checkFileType === '.docx') {
      fileType = 'application/vnd.ms-word';
    }
    if (checkFileType === '.xls') {
      fileType = 'application/vnd.ms-excel';
    }
    if (checkFileType === '.png') {
      fileType = 'image/png';
    }
    if (checkFileType === '.jpg') {
      fileType = 'image/jpeg';
    }
    if (checkFileType === '.jpeg') {
      fileType = 'image/jpeg';
    }
    if (checkFileType === '.gif') {
      fileType = 'image/gif';
    }
    if (checkFileType === '.csv') {
      fileType = 'text/csv';
    }
    if (checkFileType === '.json') {
      fileType = 'application/json';
    }

    return fileType;
  }

  saveBlob(response, filename: string) {

    const navigator: any = window.navigator;
    const fileType = this.retornaTipoArquivo(filename);

    const blob = new Blob([response], { type: fileType });
    if (typeof navigator.msSaveBlob !== 'undefined') {
      // IE workaround
      navigator.msSaveBlob(blob, filename);
    } else {
      const URL = window.URL;
      const downloadUrl = URL.createObjectURL(blob);
      if (filename) {
        const a = document.createElement('a');
        if (typeof a.download === 'undefined') {
          window.location.href = downloadUrl;
        } else {
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
        }
      } else {
        window.location.href = downloadUrl;
      }
      // cleanup
      setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100);
    }
  }



  openBlob(response) {
    window.open(URL.createObjectURL(response), '_blank');
  }

  openBlobModal(response, nomeArquivo?, urlRetorno?) {

    // let link = URL.createObjectURL(response);

    const dialogRef = this.dialog.open(VisualizadorPdfComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        arquivo: response,
        nomeArquivo: nomeArquivo !== undefined && nomeArquivo !== null ? (nomeArquivo + '.pdf') : 'documento.pdf'
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (urlRetorno !== null && urlRetorno !== undefined) {
        this.router.navigate([urlRetorno]);
      }
    });

    // const url = this.router.createUrlTree(['/visualizador-pdf', encodeURI(link)])

    // window.open(url.toString(), '_blank');
  }

  mostrarImagemBlob(response, legenda) {

    const reader = new FileReader();

    reader.onloadend = () => {


      const album: IAlbum = { src: reader.result as string, thumb: '', caption: legenda };

      this.lightbox.open([album], 0);
    };

    reader.readAsDataURL(response);

    // const url = this.sanitizer.sanitize(
    //   SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(response)));

    // const album: IAlbum = { src: url, thumb: '', caption: legenda };

    // this.lightbox.open([album], 0);

  }

  mostrarImagemBase64(img, legenda) {

    const album: IAlbum = { src: img, thumb: '', caption: legenda };

    this.lightbox.open([album], 0);

    // const url = this.sanitizer.sanitize(
    //   SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(response)));

    // const album: IAlbum = { src: url, thumb: '', caption: legenda };

    // this.lightbox.open([album], 0);

  }

  ePDF(filename: string) {
    const extensao = filename.split('.').pop().toLowerCase();
    return extensao === 'pdf';
  }

  eImagem(filename: string) {
    const extensao = filename.split('.').pop().toLowerCase();
    return extensao === 'png' || extensao === 'gif' || extensao === 'jpg' || extensao === 'jpeg' || extensao === 'bmp';
  }

  rodaScriptTabEnter() {
    $(document).ready(function () {
      $('input').keypress(function (e) {
        let code = null;
        code = e.keyCode ? e.keyCode : e.which;
        return code === 13 ? false : true;
      });

      $('input').keydown(function (e) {
        // Obter o próximo índice do elemento de entrada de texto
        let next_idx = $('input').index(this) + 1;

        // Obter o número de elemento de entrada de texto em um documento html
        let tot_idx = $('body').find('input').length;

        // Entra na tecla no código ASCII
        if (e.keyCode === 13) {
          if (tot_idx === next_idx) {
            // Vá para o primeiro elemento de texto

            // Obter o número de elemento de entrada de texto em um documento html
            if ($('body').find('textarea').length > 0) {
              $('body').find('textarea').focus();
            } else {
              $('input:eq(0)').focus();
            }
          } // Vá para o elemento de entrada de texto seguinte
          else {
            $('input:eq(' + next_idx + '), textarea:eq(' + next_idx + ')').focus();
          }
        }
      });
    });
  }

  cortaTexto(texto: string, larguraMaxima: number, tamanho: number) {
    if ($('body').width() <= larguraMaxima) {
      return texto.substring(0, tamanho - 1) + '...';
    }
  }

  remover_acentos_espaco(str: string) {
    return str.normalize('NFD').replace(/[^a-zA-Zs]/g, '');
  }

  retornaUrlBase() {
    return location.origin + this.platformLocation.getBaseHrefFromDOM();
  }

  modalMercadoPago(idMP, target) {

    if (document.getElementsByClassName('mercadopago-button').length === 0) {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.setAttribute('data-preference-id', idMP);
      script.setAttribute('data-elements-color', '#f5a505');
      script.src = 'https://www.mercadopago.com.br/integrations/v1/web-payment-checkout.js';

      document.getElementById(target).appendChild(script);
      // document.body.appendChild(script);

      script.onload = () => {
        document.getElementsByClassName('mercadopago-button')[0].dispatchEvent(new Event('click'));
      };
    }
    else {
      document.getElementsByClassName('mercadopago-button')[0].dispatchEvent(new Event('click'));
    }
  }

  toFixedNoRounding(numero, n) {
    const reg = new RegExp('^-?\\d+(?:\\.\\d{0,' + n + '})?', 'g');
    const a = numero.toString().match(reg)[0];
    const dot = a.indexOf('.');
    if (dot === -1) { // integer, insert decimal dot and pad up zeros
      return a + '.' + '0'.repeat(n);
    }
    const b = n - (a.length - dot) + 1;
    return b > 0 ? (a + '0'.repeat(b)) : a;
  }

  readFile(file) {
    return new Promise((resolve, reject) => {
      // Create file reader
      let reader = new FileReader();

      // Register event listeners
      reader.addEventListener('loadend', (e: any) => resolve(e.target.result));
      reader.addEventListener('error', reject);

      // Read file
      reader.readAsArrayBuffer(file);
    });
  }

  async getAsByteArray(file) {
    const array = new Uint8Array((await this.readFile(file)) as any);
    const byteArray = [];
    for (let i = 0; i < array.length; i++) {
      byteArray.push(array[i]);
    }
    return byteArray;
  }

  toBase64(file): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.toString().replace('data:', '')
        .replace(/^.+,/, ''));
      reader.onerror = error => reject(error);
    });
  }

  toBase64ComInicio(file): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve('data:image/jpg;base64,' + (reader.result.toString().replace('data:', '').replace(/^.+,/, '')));
      reader.onerror = error => reject(error);
    });
  }

  arredondar(numero: number, qtdCasas: number) {
    let numeroString = numero.toString();

    if (numeroString.includes('.')) {
      let casas = numeroString.substring(numeroString.indexOf('.') + 1).length;

      if (casas > qtdCasas) {
        numero = Number(Number(numeroString.substring(0, numeroString.indexOf('.') + 1 + qtdCasas)).toFixed(qtdCasas));
      }
    }

    return numero;
  }

  conversarPeloWhatsapp(celular, texto) {
    let celularParaUsar = celular ? celular.replace('(', '').replace(')', '').replace(' ', '').replace('-', '').split('/')[0] : '';
    if (!celularParaUsar || celularParaUsar.length < 10 || celularParaUsar.length > 11) {
      this.notificacaoService.erroMSG('Não foi possível abrir a conversa: celular inválido!!!');
    } else {
      let link = 'https://wa.me/55' + celularParaUsar + '?text=' + encodeURIComponent(texto);
      window.open(link, '_blank');
    }
  }

  // Função para converter uma cor hexadecimal para RGB
  private hexToRgb(hex: string): [number, number, number] {
    let r = 0, g = 0, b = 0;

    // Remove o hash (#) se presente
    hex = hex.replace(/^#/, '');

    // Converte a cor hexadecimal para RGB
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    }

    return [r, g, b];
  }

  // Função para converter RGB para cor hexadecimal
  private rgbToHex(r: number, g: number, b: number): string {
    const toHex = (num: number): string => num.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  // Função para ajustar a cor com base no fator
  private adjustColor(r: number, g: number, b: number, factor: number): [number, number, number] {
    return [
      Math.min(255, Math.max(0, Math.round(r * factor))),
      Math.min(255, Math.max(0, Math.round(g * factor))),
      Math.min(255, Math.max(0, Math.round(b * factor)))
    ];
  }

  // Função para gerar uma paleta de sombras com base na cor primária
  generateShades(baseColor: string, numberOfShades: number): string[] {
    const [r, g, b] = this.hexToRgb(baseColor);
    const shades: string[] = [];

    for (let i = 1; i <= numberOfShades; i++) {
      const factor = 1 - (i / (numberOfShades + 1));
      const [newR, newG, newB] = this.adjustColor(r, g, b, factor);
      shades.push(this.rgbToHex(newR, newG, newB));
    }

    return shades;
  }

  lightenColor(hex: string, percent: number): string {
    // Ensure the percent is between 0 and 100
    percent = Math.max(0, Math.min(percent, 100));

    // Convert hex to RGB
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    // Calculate the adjustment factor
    const factor = percent / 100;

    // Lighten each color component
    r = Math.min(255, Math.floor(r + (255 - r) * factor));
    g = Math.min(255, Math.floor(g + (255 - g) * factor));
    b = Math.min(255, Math.floor(b + (255 - b) * factor));

    // Convert RGB back to hex
    const toHex = (num: number) => num.toString(16).padStart(2, '0').toUpperCase();

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  qtdCasasDecimais(valor, maxPrecisao = 10) {
    const rounded = Number(valor.toFixed(maxPrecisao));
    return rounded % 1 ? rounded.toString().split('.')[1].length : 0;
  }

  // Pega os dígitos decimais de A com precisão alta, sem notação científica
  getDecimalDigits(num, precision = 10) {
    return num.toFixed(precision).split('.')[1].split('');
  }

  // Acha a posição (1-based) da primeira casa decimal de A que é 0
  firstZeroDecimalPosition(A) {
    const digits = this.getDecimalDigits(A);
    const idx = digits.findIndex(d => d === '0');
    return idx === -1 ? digits.length : idx + 1;
  }

  // Compara A e B seguindo as regras. Retorna true or false
  compararDescontos(A, B): boolean {
    const decimalsB = this.qtdCasasDecimais(B, 4);

    const decimals = decimalsB > 0
      ? decimalsB
      : this.firstZeroDecimalPosition(A);

    const aFixed = A.toFixed(decimals);
    const bFixed = B.toFixed(decimals);

    return aFixed === bFixed;
  }

  formatarCpfCnpj(valor: string): string {
    if (!valor) {
      return '';
    }

    let numeros = valor.replace(/\D/g, '');

    // CPF: 11 dígitos
    if (numeros.length === 11) {
      return numeros.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        '$1.$2.$3-$4'
      );
    }

    // CNPJ: 14 dígitos
    if (numeros.length === 14) {
      return numeros.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
      );
    }

    // Caso não seja CPF nem CNPJ
    return valor;
  }



  multiploOuMaisProximo(
    num: number,
    base: number,
    min?: number,
    max?: number,
    mode: string = "nearest"
  ): number {
    if (base === 0) {
      throw new Error("Base não pode ser 0");
    }

    const getDecimalPlaces = (n: number) => {
      const s = n.toString();
      return s.includes('.') ? s.split('.')[1].length : 0;
    };

    const decimals = Math.max(
      getDecimalPlaces(num),
      getDecimalPlaces(base),
      getDecimalPlaces(min === null || min === undefined ? 0 : min),
      getDecimalPlaces(max === null || max === undefined ? 0 : max)
    );

    const factor = Math.pow(10, decimals);

    const intNum = Math.round(num * factor);
    const intBase = Math.round(base * factor);
    const intMin = min !== undefined ? Math.round(min * factor) : undefined;
    const intMax = max !== undefined ? Math.round(max * factor) : undefined;

    const resto = intNum % intBase;

    let down = intNum - resto;
    let up = resto === 0 ? intNum : down + intBase;

    // aplica limites
    if (intMin !== undefined) {
      down = Math.max(down, intMin);
      up = Math.max(up, intMin);
    }

    if (intMax !== undefined) {
      down = Math.min(down, intMax);
      up = Math.min(up, intMax);
    }

    // casos fora do range
    if (intMin !== undefined && intNum <= intMin) {
      return intMin / factor;
    }

    if (intMax !== undefined && intNum >= intMax) {
      return intMax / factor;
    }

    let result: number;

    switch (mode) {
      case "down":
        result = down;
        break;

      case "up":
        result = up;
        break;

      case "nearest":
      default: {
        const distDown = Math.abs(intNum - down);
        const distUp = Math.abs(up - intNum);
        result = distDown <= distUp ? down : up;
        break;
      }
    }

    return result / factor;
  }
}
